import {styled} from '@mui/system';

import zoomPalette from 'zoomPalette';

export const ModalContentContainer = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const TypographyMainTitle = styled('div')(({theme}) => ({
  marginTop: '16px',
  fontSize: '20px',
  fontWeight: 510,
  color: '#000',
}));

export const TypographyFooter = styled('div')(({theme}) => ({
  fontSize: '12px',
  color: zoomPalette.gray['60'],
}));
